import SystemCodeIndex from "./SystemCodeIndex.vue";
import SystemCodeAdd from "./SystemCodeAdd.vue";
import SystemCodeDetail from "./SystemCodeDetail.vue";
import SystemCodeEdit from "./SystemCodeEdit.vue";
import SystemCodeUpload from "./SystemCodeUpload.vue";

let routes= [
    {
        path: '',
        meta: {
          title: "List System Code",
        },
        name: "SystemCodeIndex",
        component: SystemCodeIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create System Code",
        },
        name: "SystemCodeAdd",
        component: SystemCodeAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail System Code",
        },
        name: "SystemCodeDetail",
        component: SystemCodeDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit System Code",
        },
        name: "SystemCodeEdit",
        component: SystemCodeEdit
    },
    {
        path: 'upload',
        meta: {
          title: "Upload System Code",
        },
        name: "SystemCodeUpload",
        component: SystemCodeUpload
    },
    
]

export default routes
  